// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PokemonList_wrapper__2Ck_S"};